import type { StyleRule } from '@archipro-design/aria';

export const ProductTaggingClickableArea: StyleRule<{
    isTagging: boolean;
}> = ({ isTagging }) => ({
    height: '100%',
    width: '100%',
    position: 'relative',
    zIndex: 1,
    '&:hover': {
        cursor: isTagging
            ? `url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' height='16' width='16'%3E%3Ccircle cx='8' cy='8' r='6' fill='%23bea78c'/%3E%3C/svg%3E") 8 8,auto`
            : 'default',
    },
});
